import Vue from "vue";
import Vuetify from "vuetify/lib";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import i18n from "./i18n";
import { LangTranslator } from "vuetify/types/services/lang";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    t: ((key, ...params) => i18n.t(key, params)) as LangTranslator,
  },
  icons: {
    iconfont: "md",
  },
  theme: {
    themes: {
      light: {
        primary: "#09405A",
        accent: "#F9E217",
        anchor: "#62BBFF",
      },
    },
    options: {
      customProperties: true,
    },
  },
});
